import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { GhiChu } from "./GhiChu";

export const BtnGhiChu = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a className="dropdown-item" onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Ghi chú"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
            <img  src="/app-assets/images/icon-button-edit-v2.png"
          />
        </PopoversBootrap>
        <span class="vertical-align-v2">Ghi chú</span>
      </a>
      {show && <GhiChu show={show} onHide={handleClose} NhanVayId={item.ID} />}
    </>
  );
};
